import { Link } from 'react-router-dom';
import { Zap } from 'lucide-react';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-csgo-surface/50 border-t border-csgo-border mt-12 sm:mt-16 md:mt-24">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6 sm:py-8">
        <div className="grid md:grid-cols-3 gap-6 sm:gap-8 items-center">
          {/* Logo */}
          <div className="flex items-center gap-2 justify-center md:justify-start">
            <div className="w-8 h-8 sm:w-10 sm:h-10 bg-csgo-primary rounded-lg flex items-center justify-center neon-glow">
              <Zap className="w-4 h-4 sm:w-5 sm:h-5 text-black" />
            </div>
            <div>
              <span className="font-orbitron font-bold text-sm sm:text-base text-white">
                CSGO<span className="text-csgo-primary">LUCK</span>
              </span>
              <span className="block font-rajdhani text-xs text-csgo-textMuted">Promo Code</span>
            </div>
          </div>

          {/* Links */}
          <div className="flex flex-wrap justify-center gap-4 sm:gap-6">
            <Link 
              to="/" 
              className="font-rajdhani text-xs sm:text-sm text-csgo-textMuted hover:text-csgo-primary transition-colors"
            >
              Promo Code
            </Link>
            <Link 
              to="/rewards" 
              className="font-rajdhani text-xs sm:text-sm text-csgo-textMuted hover:text-csgo-primary transition-colors"
            >
              Rewards
            </Link>
            <Link 
              to="/how-to-claim" 
              className="font-rajdhani text-xs sm:text-sm text-csgo-textMuted hover:text-csgo-primary transition-colors"
            >
              How to Claim
            </Link>
            <a 
              href="https://csgoluck.com/r/CS2026"
              target="_blank"
              rel="noopener noreferrer"
              className="font-rajdhani text-xs sm:text-sm text-csgo-primary hover:text-csgo-primary/80 transition-colors"
            >
              Visit CSGO Luck
            </a>
          </div>

          {/* 18+ Badge */}
          <div className="flex items-center justify-center md:justify-end gap-3">
            <div className="w-8 h-8 sm:w-10 sm:h-10 bg-red-500/20 rounded-lg flex items-center justify-center border border-red-500/30">
              <span className="font-orbitron font-bold text-red-400 text-xs sm:text-sm">18+</span>
            </div>
            <span className="font-rajdhani text-xs text-csgo-textMuted">
              Gamble<br />Responsibly
            </span>
          </div>
        </div>

        {/* Copyright & Disclaimer */}
        <div className="mt-6 sm:mt-8 pt-4 sm:pt-6 border-t border-csgo-border text-center">
          <div className="flex flex-wrap justify-center gap-3 sm:gap-4 mb-3 sm:mb-4">
            <Link 
              to="/privacy-policy" 
              className="font-rajdhani text-xs text-csgo-textMuted hover:text-csgo-primary transition-colors"
            >
              Privacy Policy
            </Link>
            <span className="text-csgo-border">|</span>
            <Link 
              to="/cookies" 
              className="font-rajdhani text-xs text-csgo-textMuted hover:text-csgo-primary transition-colors"
            >
              Cookie Policy
            </Link>
          </div>
          <p className="font-rajdhani text-xs text-csgo-textMuted mb-2 px-4">
            This is an independent affiliate website promoting CSGO Luck. We are not affiliated with Valve Corporation or Steam.
          </p>
          <p className="font-rajdhani text-xs text-csgo-textMuted">
            &copy; {currentYear} CSGO Luck Promo Code. All rights reserved. | Gamble responsibly. 18+ only.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
